import React, { useState } from 'react'
import {
    Box,
    Checkbox,
    Divider,
    FormControlLabel,
    IconButton,
    InputAdornment,
    Stack,
    TextField,
    Typography,
    useTheme,
} from '@mui/material';
import Button from '../../components/Button/Button';
import { useForm } from 'react-hook-form';
import { encryptPasswordAES } from '../../services/EncriptPasswordAES';
import { adminResetExpiredPasswordOtp } from '../../api/login/loginService';
import { useSnackbar } from '../../components/MUIComponent/FeedbackComponent/SnackBar/SnackbarContext';
import { Link } from 'react-router-dom';


const PeriodicOtpVerification = ({ userName, registeredUserName, password, onCancel }) => {
    const theme = useTheme();
    const isDark = theme.palette.mode === 'dark';
    const { showSnackbar } = useSnackbar();
    const {
        register,
        handleSubmit,
        formState: { errors, isSubmitting },
    } = useForm();

    const [position, setPosition] = React.useState(50);

    const handleVerifyOtp = async (data) => {
        try {
            const result = await adminResetExpiredPasswordOtp({
                userName,
                otp: data.Otp,
                newPassword: encryptPasswordAES(password || ''),
            });
            if (result?.success === true) {
                showSnackbar(result?.message, 'success');
                onCancel?.();
                return;
            }
            showSnackbar(result?.message, 'error');
        } catch (err) {
            showSnackbar(err.message, 'error');
        }
    };

    return (
        <Box minHeight="350px">
            <Box mb={1}>
                <Typography
                    variant="h6"
                    mb={{ xs: 1, sm: 1, md: 2, lg: 1, xl: 2 }}
                    color="#1d293d"
                    className="card-title text-center"
                    fontSize={{ xs: 20, sm: 20, md: 26, lg: 22, xl: 26 }}
                >
                    Verify OTP
                </Typography>
                <Typography variant="body2" color="rgba(0,0,0,0.6)">
                    Enter the OTP sent to your registered email
                    {(registeredUserName || userName) ? (
                        <>
                            {' '}
                            <Typography component="span" variant="body2" fontWeight={600} color="#1d293d">
                                {registeredUserName || userName}
                            </Typography>
                        </>
                    ) : null}
                </Typography>
            </Box>
            <Box mt={2}>
                <form noValidate onSubmit={handleSubmit(handleVerifyOtp)}>
                    <Box
                        sx={{
                            mx: 'auto',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: { xs: 2, sm: 2, md: 2, lg: 1, xl: 2 },
                            height: '100%',
                        }}
                    >
                        <TextField
                            fullWidth
                            size="small"
                            className={`autofill_inputlog ${isDark ? 'darkmd' : 'lightmd'}`}
                            label="OTP"
                            InputLabelProps={{
                                sx: {
                                    color: '#2c2c2c',
                                },
                            }}
                            inputProps={{
                                style: {
                                    color: '#2c2c2c',
                                },
                                placeholder: 'Enter 6-Digits OTP',
                                maxLength: 6,
                                inputMode: 'numeric',
                                pattern: '[0-9]*',
                            }}
                            sx={{
                                mb: 1,
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: '8px',
                                    backgroundColor: '#fff',
                                    '& fieldset': {
                                        borderColor: '#e2e8f0',
                                    },
                                    '&:hover fieldset': {
                                        borderColor: '#e2e8f0',
                                    },
                                    '&.Mui-focused fieldset': {
                                        borderColor: '#e2e8f0',
                                    },
                                },
                                '& .MuiInputLabel-root': {
                                    color: '#2c2c2c',
                                    '&.Mui-focused': {
                                        color: '#1976d2',
                                    },
                                },
                                '& .MuiOutlinedInput-input': {
                                    color: '#334155',
                                },
                            }}
                            error={!!errors.Otp}
                            {...register('Otp')}
                            onInput={(e) => {
                                e.target.value = e.target.value.replace(/\D/g, '');
                            }}
                        />
                        <Box className="modal-btn-voilet">
                            <Button
                                variant="contained"
                                fullWidth
                                bgColor={theme.palette.background.bgpurple}
                                textColor={theme.palette.custom.whitetext}
                                padding="12px 10px"
                                fontSize="16px"
                                disabled={isSubmitting}
                                type="submit"
                                sx={{ width: '100%', fontWeight: 600 }}
                            >
                                {isSubmitting ? (
                                    <div class="loaderbtn"></div>
                                ) : (
                                    "Verify OTP"
                                )}
                            </Button>
                        </Box>

                        <Divider
                            sx={{
                                mt: { xs: 2, sm: 2, md: 2, lg: 1, xl: 2 },
                                borderColor: '#adadad !important',
                                '& .MuiDivider-wrapper': {
                                    fontSize: '13px',
                                    fontWeight: 500,
                                    color: '#adadad',
                                },
                                '--Divider-childPosition': `${position}%`,
                            }}
                        >

                        </Divider>

                        <Box
                            pt={1}
                            textAlign={'center'}
                            color={'#adadad'}
                            fontSize={13}
                            fontWeight={400}
                        >
                            <Link sx={{ cursor: 'pointer' }} style={{ color: '#adadad' }} to="/privacy-notice" target="_blank"
                                rel="noopener noreferrer">
                                Privacy Notice
                            </Link>{' '}
                            |{' '}
                            <Link sx={{ cursor: 'pointer' }} style={{ color: '#adadad' }} to="/terms" target="_blank"
                                rel="noopener noreferrer">
                                Term of service
                            </Link>
                        </Box>
                    </Box>
                </form>
            </Box>
        </Box>
    )
}

export default PeriodicOtpVerification;
